import { render, staticRenderFns } from "./seaImportBookingBasic.vue?vue&type=template&id=13fff5f4&scoped=true&"
import script from "./seaImportBookingBasic.vue?vue&type=script&lang=js&"
export * from "./seaImportBookingBasic.vue?vue&type=script&lang=js&"
import style0 from "./seaImportBookingBasic.vue?vue&type=style&index=0&id=13fff5f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fff5f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13fff5f4')) {
      api.createRecord('13fff5f4', component.options)
    } else {
      api.reload('13fff5f4', component.options)
    }
    module.hot.accept("./seaImportBookingBasic.vue?vue&type=template&id=13fff5f4&scoped=true&", function () {
      api.rerender('13fff5f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/pageUICustom/seaImportBookingBasic.vue"
export default component.exports